// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"e12d5641","438":"290a30a1","506":"6f969b62","530":"d315bd9d","533":"8ce644cc","549":"d1d2321c","642":"ea09d571","787":"c8713c9f","925":"1f7608b3"}[chunkId] + ".chunk.js";
};